import {useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import styles from './styles.module.scss';

const AuthLayout = () => {
  useEffect(() => {
    document.documentElement.style.setProperty('--position-left-noti', '0');
  }, []);

  return (
    <div className={styles.authLayout}>
      <div className={styles.leftSection}>
        <div className={styles.title}>
          <span>Welcome to</span>{' '}
          <span style={{fontWeight: '700'}}>BnK IDP</span>
        </div>
        <div className={styles.description}>
          Natural Language Powered Document Processing
        </div>
      </div>
      <div className={styles.rightSection}>
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
